import toast from "react-hot-toast";

export const toastService = {
  /**
   * Show success message
   * @param message - The success message to display
   * @param duration - Duration in milliseconds (default: 5000)
   */
  success: (message: string, duration?: number) => {
    return toast.success(message, {
      duration: duration || 5000,
    });
  },

  /**
   * Show error message
   * @param message - The error message to display
   * @param duration - Duration in milliseconds (default: 8000)
   */
  error: (message: string, duration?: number) => {
    return toast.error(message, {
      duration: duration || 8000,
    });
  },

  /**
   * Show info message
   * @param message - The info message to display
   * @param duration - Duration in milliseconds (default: 5000)
   */
  info: (message: string, duration?: number) => {
    return toast(message, {
      duration: duration || 5000,
      icon: "ℹ️",
      style: {
        background: "#3b82f6",
        color: "#fff",
      },
    });
  },

  /**
   * Show warning message
   * @param message - The warning message to display
   * @param duration - Duration in milliseconds (default: 6000)
   */
  warning: (message: string, duration?: number) => {
    return toast(message, {
      duration: duration || 6000,
      icon: "⚠️",
      style: {
        background: "#f59e0b",
        color: "#fff",
      },
    });
  },

  /**
   * Show loading message
   * @param message - The loading message to display
   */
  loading: (message: string) => {
    return toast.loading(message);
  },

  /**
   * Dismiss a specific toast
   * @param toastId - The ID of the toast to dismiss
   */
  dismiss: (toastId?: string) => {
    toast.dismiss(toastId);
  },

  /**
   * Show promise-based toast (auto success/error)
   * @param promise - The promise to track
   * @param messages - Messages for loading, success, and error states
   */
  promise: <T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: any) => string);
    }
  ) => {
    return toast.promise(promise, messages);
  },

  /**
   * Custom toast with options
   * @param message - The message to display
   * @param options - Custom toast options
   */
  custom: (message: string, options?: any) => {
    return toast(message, options);
  },
};

export default toastService;
